type MenuItem = {
  icon?: any;
  selected?: boolean;
  label: string;
} & ({ href: string; onClick?: never } | { onClick: () => void; href?: never });

export default function Menu({ items }: { items: MenuItem[] }) {
  return (
    <div className="flex flex-col p-2">
      {items.map((item) => {
        const className = `px-2 py-1 text-left bg-transparent hover:bg-slate-100 text-sm font-medium ${
          item.selected
            ? "bg-default-50 text-default-800"
            : "text-slate-500/80 hover:text-slate-700"
        }`;

        const Icon = item.icon;
        const content = Icon ? (
          <span className="flex items-center space-x-2">
            <Icon className="w-4 h-4" />
            <span>{item.label}</span>
          </span>
        ) : (
          item.label
        );

        return item.href ? (
          <a key={item.label} href={item.href} className={className}>
            {content}
          </a>
        ) : (
          <button onClick={item.onClick} className={className} type="button">
            {content}
          </button>
        );
      })}
    </div>
  );
}
